
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import {
  getCouponTypeName,
  getCouponContent,
  getCouponThreshold,
  getCouponGoodsTypeName,
} from '@/common/coupon'
@Component({
  components: {}
})
export default class extends ListViewVue {
  listType = "router";
  getList() {
    return this.$post("/manager/coupon/list", this.mesureData);
  }
  getTypeName = getCouponTypeName;
  getContent = getCouponContent;
  getThreshold = getCouponThreshold;
  getGoodsTypeName = getCouponGoodsTypeName;

  /** 用券时间类型 0时间范围 1领券后多少天，要拼日期所以留在组件里 */
  getTimeText(row) {
    if (Number(row.timeType) == 1) {
      return `领券后${row.timeValue}天内可用`;
    }
    if (!row.startTime && !row.endTime) {
      return "-";
    }
    return `${this.$format(row.startTime)} ~ ${this.$format(row.endTime)}`;
  }

  /**
   * 切换生效状态。ui-switch 没有内部状态，完全由 row.status 驱动，
   * 所以失败时不改 row.status，开关就会停在原状态。
   */
  async setStatus(row, status) {
    await this.$postError("/manager/coupon/set-status", {
      id: row.id,
      status,
    });
    row.status = status;
    this.$success("操作成功");
  }

  async delRow(id) {
    await this.$postError("/manager/coupon/delete", {
      id,
    });
    this.$success("删除成功");
    this.refresh();
  }

  operat(id?) {
    if (id) {
      return this.$goto({
        name: "coupon-operat",
        query: {
          id,
        },
      });
    }
    return this.$goto({
      name: "coupon-operat",
    });
  }
}
